import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { IBin } from './bin';
import { catchError, tap, map } from 'rxjs/operators';
import * as myGlobals from '../global';
import { HttpClientSecured } from '../services/http-client-secured';

@Injectable({
  providedIn: 'root'
})
export class BinesService {
  private _binesURL = myGlobals.baseApi + '/webadmin/v1/bins';
  private _addBinURL = myGlobals.baseApi + '/webadmin/v1/bin';
  formData: IBin;

  constructor(private http: HttpClientSecured) {}

  getBines() {
    return this.http.get<any>(this._binesURL);
  }

  getBin(itemId: number): Observable<IBin | undefined> {
    return this.getBines().pipe(map((bines: IBin[]) => bines.find(p => p.prefix === itemId)));
  }

  addBin(bin) {

    return this.http.post<any>(this._addBinURL, bin);
  }
  // getActiveBines(): Observable<IBin[]> {
  //   return this.http.get<IBin[]>(this._activeURL).pipe(
  //     tap(data => console.log('AllActive: ' + JSON.stringify(data))),
  //     catchError(this.handleError)
  //   );
  // }

  private handleError(err: HttpErrorResponse) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
